
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artworks/[...slug]",
      function () {
        return require("private-next-pages/artworks/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artworks/[...slug]"])
      });
    }
  